<template>
  <div
    class="header"
    :style="
      schoolCode == '14197' && type == '1' ? 'background-color:#f7f7f7' : ''
    "
  >
    <div
      @click="type == '0'||type == '1' ? pushBack(route) : !casLogin === true ? back() : ''"
    >
      <i class="back" v-if="!casLogin && isShowArrow"></i>
      <h3>{{ title }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    route: {
      type: String,
      default: ""
    },
    casLogin: {
      type: Boolean,
      default: false
    },
    isShowArrow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      schoolCode: ""
    };
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
  },
  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
    pushBack(route) {
      if (this.schoolCode == "14197" && this.type == "1") {
        window.location.href = "http://wap.hbei.com.cn";
        return;
      }
      this.$router.push(route);
    }
  }
};
</script>

<style scoped lang="less">
.header > div {
  display: flex;
  padding-left: 20px;
}
.header {
  display: flex;
  align-items: center;
  height: 50px;
  background-color: @attendance-color-3;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: @attendance-color-3;
  z-index: 999;
}
.header h3 {
  line-height: 18px;
}
.header .back {
  width: 20px;
  height: 20px;
  margin: 0 10px 0 0px;
  background: url(../../../static/img/back.png) no-repeat center center;
  background-size: 10px 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue